import React, { useState } from "react";
import styled from "styled-components";
import logo from "../assets/asitesLogoDL.png";
import { FaRegUserCircle } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";
import { ImHome } from "react-icons/im";
import { GrCycle } from "react-icons/gr";
import { MdTaskAlt } from "react-icons/md";
import { FaChartLine } from "react-icons/fa6";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { currentUser } = useAuth();

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Hamburger onClick={toggleSidebar}>
        <div />
        <div />
        <div />
      </Hamburger>
      <Container isOpen={isOpen}>
        <h1 className="sidebarTitle">
          <Link to={"/app"}>
            <img src={logo} alt="Logo" />
          </Link>
        </h1>
        <Link to={"/account"} className="link-styles">
          <div className="user">
            <FaRegUserCircle className="icon" />
            <h2>{currentUser?.displayName}</h2>
          </div>
        </Link>
        <div className="daily">
          <h3>Daily</h3>
          <p>
            <ImHome /> <span>Home</span>
          </p>
          <p>
            <GrCycle /> <span>Habit Tracker</span>
          </p>
          <p>
            <MdTaskAlt /> <span>To Do List</span>
          </p>
          <p>
            <FaChartLine /> <span>Progress Charts</span>
          </p>
        </div>
        <div className="daily">
          <h3>ASites Management</h3>
          <p>Clients</p>
          <p>Employees</p>
          <p>Projects</p>
          <p>Revenue</p>
        </div>
        <div className="daily">
          <h3>Features</h3>
          <p>To-do Lists</p>
          <p>Notepad</p>
          <p>Projects</p>
          <p>Revenue</p>
        </div>
      </Container>
      {isOpen && <Overlay onClick={toggleSidebar} />}
    </>
  );
};

const Hamburger = styled.div`
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 1000;
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 20px;
  cursor: pointer;

  div {
    background-color: #fff;
    height: 3px;
    border-radius: 2px;
    transition: 0.3s ease;
  }

  @media (max-width: 920px) {
    display: flex;
  }
`;

const Container = styled.div`
  background-color: #171c29;
  padding: 20px;
  height: 100vh;
  width: 240px;
  position: fixed;
  top: 0;
  left: ${(props) => (props.isOpen ? "0" : "-100%")};
  transition: left 0.3s ease;
  z-index: 999;

  .sidebarTitle {
    font-size: 1vw;
    font-weight: 200;
    img {
      margin: auto;
      margin-top: 5%;
      margin-left: 7%;
      width: 120px;
    }
  }
  .user {
    margin-top: 2em;
    margin-bottom: 2em;
    background-color: #20273a;
    padding: 15px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    .icon {
      font-size: 1.9em;
    }
    h2 {
      font-size: 21px;
      font-weight: 400;
    }
  }
  div {
    margin-bottom: 4em;
    h3 {
      font-weight: 400;
      color: #b05ff1;
      margin-bottom: 10px;
    }
    p {
      margin-bottom: 20px;
      background-color: #20273a;
      padding: 15px;
      border-radius: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 10px;
      svg {
        font-size: 24px;
      }
    }
  }

  @media (min-width: 921px) {
    left: 0;
    width: 240px;
  }
  @media (max-width: 920px) {
  }

  @media (max-width: 1603px) {
    width: 80px;
    padding: 10px;
    .sidebarTitle {
      display: none;
    }
    .user {
      h2 {
        display: none;
      }
    }
    div {
      p {
        display: flex;
        justify-content: center;
        span {
          display: none;
        }
      }
      svg {
        display: block;
      }
    }
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
`;

export default Sidebar;
